import React from "react";
import { type NextPage } from "next";
import { compact } from "lodash";
import { getLandingPageProps, getPageMetaImage, type LandingPageProps } from "utils";
import { Page } from "components/page";
import {
  WarehouseHero,
  WarehouseAsCdp,
  WarehouseCaseStudies,
  WarehouseCdpDiagram,
  WarehouseAccordion,
  WarehouseSecurityFeatures,
  WarehouseWordCloud,
  WarehouseUseCaseTabs,
  WarehouseFaq,
  WarehouseCustomers,
  WarehouseResources,
  WarehouseQuote,
  WarehouseAidVideo,
} from "components/solutions/warehouses";
import { DataTeamsCards } from "components/platform-overview-content";
import { WarehouseCdpProvider, WarehouseCdpVariants } from "contexts/warehouse-cdp-context";
import { SolidPlate } from "ui/plates";

const featuredCaseStudySlugs = ["petsmart", "weight-watchers", "wmg", "morning-brew"];

const Snowflake: NextPage<LandingPageProps> = ({ page, announcementBanner, caseStudies }) => {
  const warehouseConfig = WarehouseCdpVariants.snowflake;
  // Ensure correct order of case studies
  const featuredCaseStudies = compact(
    featuredCaseStudySlugs.map((slug) => caseStudies.find((caseStudy) => caseStudy.customer.slug === slug)),
  );

  return (
    <Page
      title={page.metaTitle}
      description={page.metaDescription}
      image={getPageMetaImage({ src: page.metaImageUrl, alt: page.metaTitle })}
      announcementBanner={announcementBanner}
      bgColor="new.blue.150"
      footerOptions={{ variant: "blue" }}
    >
      <WarehouseCdpProvider warehouse={warehouseConfig}>
        <WarehouseHero title={page.title} description={page.description} />
        <WarehouseCustomers customers={page.customers} />
        <WarehouseAsCdp />
        <WarehouseQuote />
        <WarehouseCaseStudies caseStudies={featuredCaseStudies} />
        <SolidPlate theme="dark" bgColor="new.blue.950" spotlightColor="new.blue.900">
          <WarehouseCdpDiagram theme="dark" />
          <WarehouseAccordion theme="dark" />
          <WarehouseSecurityFeatures theme="dark" bgColor="new.blue.950" />
        </SolidPlate>
        <WarehouseAidVideo />
        <WarehouseWordCloud />
        <WarehouseResources />
        <DataTeamsCards warehouse={warehouseConfig} />
        <WarehouseUseCaseTabs />
        <WarehouseFaq />
      </WarehouseCdpProvider>
    </Page>
  );
};

export const getStaticProps = getLandingPageProps("/solutions/snowflake-cdp", {
  loadCaseStudies: featuredCaseStudySlugs,
});

export default Snowflake;
